import { PencilBoxOutlineIcon } from './PencilBoxOutlineIcon';

/**
 * author: Austin Andrews
 * id 48A9B269-08B8-4DCB-85F1-68F2334DC004
 * name pencil-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-box-outline.svg
 * tags
 * - Drawing / Art 
 */
export const EditBoxOutlineIcon = PencilBoxOutlineIcon;
export default EditBoxOutlineIcon